import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const shopService = { constants, ...slice, sagas };

export default shopService;

